class SessionStorage {

    /**
     * This is used to set a specific item in storage
     * @param {string} key - the key for the item
     * @param {object} value - the value
     * @returns {string} value that was set
     */
    static setItem(key, value) {
      // Check if this is a device-related key
      if (key.includes('deviceKey') || key.includes('deviceGroupKey') || key.includes('randomPasswordKey')) {
        console.log(`Storing device key: ${key}`);
        // Store in both sessionStorage and localStorage for persistence
        sessionStorage.setItem(key, value);
        localStorage.setItem(key, value);
      } else {
        sessionStorage.setItem(key, value);
      }
      return sessionStorage.getItem(key);
    }
  
    /**
     * This is used to get a specific key from storage
     * @param {string} key - the key for the item
     * This is used to clear the storage
     * @returns {string} the data item
     */
    static getItem(key) {
        // Try to get device-related keys from localStorage first for persistence across sessions
        if (key.includes('deviceKey') || key.includes('deviceGroupKey') || key.includes('randomPasswordKey')) {
          const localValue = localStorage.getItem(key);
          if (localValue) {
            console.log(`Retrieved device key from localStorage: ${key}`);
            return localValue;
          }
        }
        return sessionStorage.getItem(key);
    }
  
    /**
     * This is used to remove an item from storage
     * @param {string} key - the key being set
     * @returns {string} value - value that was deleted
     */
    static removeItem(key) {
      // Also remove from localStorage if it's a device-related key
      if (key.includes('deviceKey') || key.includes('deviceGroupKey') || key.includes('randomPasswordKey')) {
        localStorage.removeItem(key);
      }
      return sessionStorage.removeItem(key);
    }
  
    /**
     * This is used to clear the storage
     * @returns {string} nothing
     */
    static clear() {
      // Don't clear device keys from localStorage when clearing session
      sessionStorage.clear();
    }
}
  
export default SessionStorage;